import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCT_DETAILS_SUCCESS,
    GET_PRODUCT_DETAILS_ERROR,
} from 'src/pages/receiveSets/redux/actions/index.js';

export default function* getProductDetails(action) {
    const { productCFN, salesOrg } = action.payload;
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}/products/productDetails/${encodeURIComponent(productCFN)}?salesOrg=${encodeURIComponent(salesOrg)}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: GET_PRODUCT_DETAILS_SUCCESS,
            payload: result.productDetails,
        });
        // const isSetDetails = resourceType
        //     ?.split(',')
        //     .includes('BILL_OF_MATERIALS');
        // const object = {
        //     data: result?.productDetails,
        //     searchField: isSetDetails ? 'bom' : 'cfn',
        //     ascending: true,
        // };
        // const param = isSetDetails ? 'billOfMaterials' : 'foundInSets';
        // const sortedProducts = sortSetItemDetails({
        //     ...object,
        //     objectField: param,
        // },isSetDetails);
        // const sortedData = {
        //     ...result?.productDetails,
        //     [param]: sortedProducts,
        // };
        // yield put({
        //     type: SORT_PRODUCT_DETAILS,
        //     payload: sortedData,
        // });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCT_DETAILS_ERROR,
            payload: errorHandler('503'),
        });
    }
}
